<template>
  <modal-layout :is-open="isOpen" class="Modal__accordion" @close="modalClose">
    <div class="Modal_area">
      <div
        class="Modal__cross-box _cross"
        role="button"
        tabindex="0"
        aria-label="クラス詳細モーダルを閉じる"
        @click="modalClose"
      >
        <span class="Modal__cross" />
      </div>
      <div class="Modal_title">
        <span class="Modal_title_date">時間で選ぶ</span>
      </div>
      <div class="Modal_inner modal__container">
        <ul class="Search_time_list">
          <li v-for="item in items" :key="item.time" class="Search_time_list_box">
            <a
              class="Search_time_list_link"
              @click="searchTime(item.time)"
            >
              <span class="Search_time_list_link_tx">{{ item.time }}分</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </modal-layout>
</template>
<script>
import ModalLayout from '@/views/components/modals/ModalLayout.vue'
export default {
  name: 'MelonTVScheduleModal3',
  components: { ModalLayout },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    filterTime: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      items: [
        { time: 5 },
        { time: 10 },
        { time: 15 },
        { time: 30 },
        { time: 45 },
        { time: 60 },
        { time: 75 },
        { time: 90 }
      ]
    }
  },
  methods: {
    modalClose() {
      this.$emit('close')
    },
    searchTime(time) {
      this.$emit('searchMelonTv', { searchTime: time })
      this.$emit('close')
    }
  }
}
</script>
